// Versão do app - gerado automaticamente
export const APP_VERSION = '5.46'
export const BUILD_DATE = '12/06/2026, 17:55'
